import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";
import useMediaQuery from "@mui/material/useMediaQuery";



const Educationcs1 = () => {
    const isMobile = useMediaQuery("(max-width: 900px)");
    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);

  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      <Box sx={{ position: "relative", overflow: "hidden" }} >
        {/* Background Half-Moon Shape */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: isMobile ? "100%" : "70%",
            height: "100%",
            background: "linear-gradient(to right, #E0F7FA, #B2EBF2, #80DEEA)",
            borderTopLeftRadius: isMobile ? "100% 40%" : "100% 100%",
            borderBottomLeftRadius: isMobile ? "100% 40%" : "100% 100%",
            zIndex: 0,
          }}
        />
      
        {/* Actual Content (your original layout) */}
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: "center",
            justifyContent: "center",
            width: isMobile ? "100%" : "90%",
            padding: isMobile ? "30px 15px" : "50px 50px",
            gap: "50px",
            boxSizing: "border-box",
            margin: "0 auto",
            minHeight: isMobile ? "auto" : "100vh",
            paddingTop: isMobile ? "120px" : "0px",
            marginBottom: isMobile ? "100px" : "-50px",
            zIndex: 1,
          }}
        >
          {/* Left Content */}
          <Box
            sx={{
              flex: 1,
              textAlign: isMobile ? "center" : "left",
              margin: "0px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: isMobile ? "50px" : "60px",
                marginTop: "-20px",
              }}
              mb={8}
            >
             An Education in Pandemic Response
            </Typography>
      
            <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
            A regional, comprehensive, Hispanic-serving institution, is committed to giving access to a wide array of academic subjects and meaningful life experiences. That well-rounded education prepares students with the problem-solving and social skills needed to navigate a rapidly changing world.</Typography>
            <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
            Wanting to preserve the college experience for its students, the university responded aggressively to the COVID-19 pandemic to amplify its remote learning capabilities — and went even further by seeking a solution that would enable it to bring students, faculty and staff safely back to campus.</Typography>
            <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
            It engaged Tech Informatic Solutions and Spartan Medical to integrate COVID-19 rapid and PCR testing with a HIPAA-compliant, multi-functional digital platform to continuously guide students, faculty and staff through a safe return to campus.</Typography>
      
      
          </Box>
      
          {/* Right Image */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0px",
              marginTop: isMobile ? "50px" : "0px",
            }}
          >
            <img
              src="/image/educationcss1.jpg"
              alt="About Us"
              style={{
                width: isMobile ? "90%" : "100%",
                maxHeight: "100%",
                objectFit: "cover",
                borderRadius: "10px",
                boxShadow: `
                  0px 12px 25px rgba(0, 0, 0, 0.6),  
                  inset 0px 10px 20px rgba(255, 255, 255, 0.15),
                  inset 0px -10px 30px rgba(0, 0, 0, 0.7),
                  inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
                  inset -10px 0px 20px rgba(255, 255, 255, 0.2)
                `,
              }}
            />
          </Box>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 10 }}>
      
        
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Business Needs
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Few events changed the world as quickly as the COVID-19 pandemic. The pandemic forced universities around the globe to restrict campus operations and, where possible, shift resources to delivering remote learning. But many universities view remote learning as a stop-gap solution. Some students underperform in a remote learning model. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Additionally, for many students, the life-changing experience of “going to college” means attending in-person classes, living on campus, creating face-to-face connections as well as participating in, and attending athletic and social events. The pandemic threatened an end to all of that.  </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        Dedicated to its academic mission and the community it serves, the institute needed to safely return to in-person campus learning, living, athletics and work.
        </Typography>



         {/* outcome Section */}
       <Typography variant="h4" fontWeight="bold" mb={-12}>
         Outcomes
        </Typography>
       
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={2}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "15-minute rapid antigen and PCR tests amplify test accuracy and throughput",
                "Mitigates exposure through user health QR codes scanned at campus-wide checkpoints",
                
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Responsive app design allows for access on mobile devices without downloading special software",
                
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>







      <Container sx={{ py: 10 }}>
      
       
        <Typography  variant="h4" fontWeight="bold" mb={3}>
         Solution
        </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Restoring the dream
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Dr. Donna Souder Hodge,Institiutes’s chief strategy officer and COVID-19 director, led the University’s effort to safely restore campus operations. Stressing institutes’s pledge to the community it serves, she says, “Our students are first-generation students. They are underrepresented minorities. They are first-generation Pell eligible. Many are adult learners. We’re committed to ensuring they all receive the benefits of in-person learning while keeping campus safe from the virus.”  </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        Through the early stages of the pandemic, the institute maintained a hybrid model of classroom delivery combining remote and in-person learning. Eventually though, the COVID-19 positivity rate in Pueblo County and, consequently, on the campus began to skyrocket. The institute's own COVID-19 team no longer had the capacity for virus testing at the scale required to safely deliver in-person learning. And the University realized that testing alone was inadequate. The institute's determined it needed an end-to-end response that would integrate virus testing, contact tracing and data-driven monitoring and reporting in a manageable solution. </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Learning together: the power of partnerships
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Souder Hodge knew they needed support from technology partners with public sector experience. “We searched for companies that were solving problems for states, for counties, for our government,” she says. “That eventually led us to Spartan Medical. Spartan could staff a test collection site, they could administer antigen rapid tests, and importantly, they partnered with Tech Informatic Solutions to very quickly provide an online solution.”
        </Typography>
         <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
         Spartan Medical brought fast, scalable and highly accurate COVID-19 testing capabilities, licensed medical staff for on-campus test collection, and certified contact tracers to the response program. Tech Informatic Solutions, with its Smart Back to School application platform, added robust, data-driven digital capabilities for self-health assessments, virus test scheduling and reporting, campus monitoring and virus tracking analytics. The sum of those capabilities delivered the end-to-end solution they sought.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        “Within two weeks of bringing the solution online, we were able to do a complete test of every student and employee who was living, learning and working on campus,” says Souder Hodge. “We were able to safely reopen our residence halls and return our student athletes back to practice and competition. Our positivity rate dropped from over 20% in the fall semester to below 1% within a month and a half of beginning the partnership with Tech Informatic Solutions and Spartan Medical.” </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Rapid testing yields rapid results</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        At the institute, Spartan Medical administers self-contained, point-of-care qSARS-CoV-2 Antigen Rapid tests. Those tests deliver highly reliable and accurate results in 15 minutes. Importantly, they can be used in any location since they do not require a reader or lab equipment for test processing. If a rapid test indicates a positive result, a confirmatory Real-Time Polymerase Chain Reaction (RT-PCR) test sample is collected and submitted to a CLIA laboratory for processing. Both Antigen and RT-PCR test results are linked to the same individual using Tech Informatic Solutions technology platform.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        Prior to rolling out Spartan Medical’s testing program, the institute was able to perform 1,300 COVID-19 tests over an academic quarter. Using Spartan Medical’s tests, in conjunction with the online scheduling capabilities of the Tech Informatic Solutions Smart Back to School platform, the institute scaled and expanded its virus testing by 10 times, performing approximately 1,000 new tests per week.</Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Advanced curriculum for reopening
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        A key component of Tech Informatic Solution’s Pandemic Response Portfolio is the Accelerate Smart platform, offering a wide range of technologies designed to help communities safely return. Smart Back to School gives the institute an online platform to sustainably manage and track all COVID-19 related activity and data in one place: </Typography>

<Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={12}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Each week, students use the platform to book a COVID-19 test with the Spartan Medical team at an on-campus test collection site.",
                "If a test result is positive, the institutes COVID-19 team is alerted via a secure dashboard and immediately leads contact tracing of any students or staff that may have been exposed.",
                "All on-campus individuals complete a daily health self-assessment through the platform. An algorithm powered knowledge base of COVID-19 symptoms queries users for symptoms of the illness and refers them for testing when indicated. All health data is compliant with HIPAA privacy mandates."
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Additionally, the daily self-assessment app issues a green, yellow or red QR code — a “health indicator” — that the user displays at campus wide checkpoints for access to facilities.",
                "Using Amazon QuickSight, a powerful business intelligence tool, campus officials can see health assessments and daily COVID-19 test results and trends broken down by demographic data such as athletic team affiliations and residence halls to prevent outbreaks within these groups.",
                "The responsive web tool is hosted on Amazon Web Services to further ensure its performance, scalability and HIPAA compliance."
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
            <motion.div
              whileHover={{ y: -5 }}
              transition={{ type: "spring", stiffness: 200, damping: 10 }}
              style={{ height: "90%" }} // 👈 ensure motion div stretches
            >
              <Box
                sx={{
                  height: "100%", // 👈 make the card full height
                  position: "relative",
                  backgroundImage: `url(${feature.bgImage})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  borderRadius: "12px",
                  p: 4,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  overflow: "hidden",
                  textAlign: "left",
                }}
              >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>



      <Typography  variant="h4" fontWeight="bold" mb={3}>
      Back-to-school success
        </Typography>
        
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        The disruption brought by the COVID-19 pandemic persists but collegiate life at the institute is returning to normal. Reflecting on their immense progress in bringing students, faculty and staff back to campus safely, Souder Hodge says, “It's really exciting to be back on campus right now. There are cars in the parking lot and students moving about campus.” </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        Souder Hodge continues, “Campus life is such a powerful and incredibly important experience for our students. With the success of our testing program, our baseball team has returned to the field with fans in the stands cheering them on. The highlight of my career was when I tweeted a photo from a recent game and one of our baseball players tweeted back at me and said, ‘Thank you for taking care of our campus and for doing everything you're doing to bring us back.’”</Typography>
        


</Container>



<Footer/>
    </Box>


  );
};

export default Educationcs1;
